import { isNull, isUndefined } from 'lodash';
const isNullable = (value: unknown) => isNull(value) && isUndefined(value);

export default isNullable;
